import { Component } from '@angular/core';

import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'apm-row-wrapper',
  templateUrl: './row-wrapper.component.html',
  styleUrls: ['./row-wrapper.component.scss'],
  standalone: false,
})
export class RowWrapperComponent extends FieldWrapper {}
